import React from 'react'
import "../Styles/Home.css"
import Color from '../Components/Colors/Color'
import { useNavigate } from 'react-router-dom'

const Home = () => {
  const navigate = useNavigate();

  const handleMoveToProductDetails = () => {
    navigate('/products')
  }


  return (
    <>
      <div className='home-container' style={{color: Color.secondaryText}}>
        
        <div className='home-text-container col-lg-7 col-md-12'>
          <h1 className='home-title animate-pulse' style={{color: Color.secondaryText}}>OPC <span className='home-title-span'>Trading</span> </h1>
          <h6 className='home-text'>
            Unleash unmatched printing prowess with our sales, maintenance, repair services, and cutting-edge equipment. 
            Elevate your business!
          </h6>
          <button className='home-explore-btn' style={{backgroundColor: Color.secondaryText, color: Color.thirdText}} onClick={handleMoveToProductDetails}>
            Explore
          </button>
        </div>
        <div className='home-images-container col-lg-5'>
          <img src='/Images/image-1.png' alt='image-1' className='home-image-1' />
          <img src='/Images/image-2.png' alt='image-2' className='home-image-2' />
        </div>

        <div className='home-image-container col-md-12'>
          {/* <img src='/Images/image-3.png' alt='image-1' className='home-image-3' /> */}
        </div>

      </div>
    </>
  )
}

export default Home